import React from 'react';
import { format, parseISO } from 'date-fns';
import {
  CellYesNoV8,
  TableCellV8,
  CellYesNoEngV8,
  CellDateTimeV8,
  CellDateV8,
  CellDateExpiryV8,
} from 'motion-components';
import { DocFilter } from './constants';

export const Grid = {
  rowSelectBackgroundColor: '#ACCEF7',
  rowInactiveFontColor: '#6b2020',
};
export const gridRowSelectedStyle = {
  backgroundColor: Grid.rowSelectBackgroundColor,
};
export const gridInactiveRowStyle = { color: Grid.rowInactiveFontColor, fontWeight: '500' };

export const firstDateUserColumn = (t) => {
  return {
    id: 'firstDate',
    header: t('Δήλωση'),
    columnName: t('Δήλωση'),
    accessorKey: 'firstDate',
    orderByField: 'firstDate',
    cell: (props) => {
      const rec = (props as any).row.original;
      const dt = rec.firstDate ? format(parseISO(rec.firstDate), 'dd/MM/yy HH:mm') : '';
      return (
        <div className="text-center">
          {dt} - {rec.firstUser ? rec.firstUser : ''}
        </div>
      );
    },
    size: 15,
  };
};

export const lastDateUserColumn = (t) => {
  return {
    id: 'lastDate',
    header: t('Αλλαγή'),
    columnName: t('Αλλαγή'),
    accessorKey: 'lastDate',
    orderByField: 'lastDate',
    cell: (props) => {
      const rec = (props as any).row.original;
      const dt = rec.lastDate ? format(parseISO(rec.lastDate), 'dd/MM/yy HH:mm') : '';
      return (
        <div className="text-center">
          {dt} - {rec.lastUser}
        </div>
      );
    },
    size: 15,
  };
};

export const isActiveColumn = (t, i18n) => {
  return {
    id: 'isActive',
    header: t('Ενεργή Εγγραφή'),
    columnName: t('Ενεργή'),
    accessorKey: 'isActive',
    orderByField: 'isActive',
    cell: TableCellV8,
    size: 7,
    meta: {
      onLabel: t('ΝΑΙ'),
      offLabel: t('ΟΧΙ'),
      type: 'checkbox',
      viewCell: i18n.language === 'gr' ? CellYesNoV8 : CellYesNoEngV8,
    },
  };
};

export const datetimeColumn = (t) => {
  return {
    cell: TableCellV8,
    meta: {
      type: 'datepicker',
      viewCell: CellDateTimeV8,
      dateFormat: 'd/M/yyyy HH:mm',
      rest: {
        showTimeSelect: true,
        timeFormat: 'HH:mm',
        timeIntervals: 15,
      },
    },
    size: 20,
  };
};

export const dateColumn = (t) => {
  return {
    cell: TableCellV8,
    meta: {
      type: 'datepicker',
      viewCell: CellDateV8,
      dateFormat: 'd/M/yyyy',
      rest: {
        showTimeSelect: false,
      },
    },
    size: 15,
  };
};

export const dateExpiryColumn = (t) => {
  return {
    cell: TableCellV8,
    meta: {
      type: 'datepicker',
      viewCell: CellDateExpiryV8,
      dateFormat: 'd/M/yyyy',
      rest: {
        showTimeSelect: false,
      },
    },
    size: 15,
  };
};

/* export const dateColumn = (t) => {
  return {
    cell: TableCellV8,
    meta: {
      type: 'datepicker',
      viewCell: () => CellDateV8(true),
      dateFormat: 'd/M/yyyy',
      rest: {
        showTimeSelect: false,
      },
    },
    size: 15,
  };
};
 */

